import { useContext } from 'react'

import { BoxLockContext } from './box-lock-context'

export function usePaywallContext() {
  const context = useContext(BoxLockContext)
  if (context.componentType !== 'paywall') {
    throw new Error('usePaywallContext should be used with a paywall component')
  }
  return context
}
